// import "../css/AboutUs.css";
// import Footerlanding from '../landing/Footerlanding';
// import Navbarlanding from '../landing/Navbarlanding';

//     const services = [
//     { title: "Digital Banking", desc: "Seamless online banking experience for individuals and businesses.", icon: "💳" },
//     { title: "AI Solutions", desc: "AI-powered analytics and automation to optimize banking operations.", icon: "🤖" },
//     { title: "Cyber Security", desc: "Advanced security protocols to protect data and transactions.", icon: "🔒" },
//     { title: "Mobile & Internet Banking", desc: "User-friendly mobile apps and online platforms.", icon: "📱" },
//     { title: "Cloud Banking", desc: "Scalable cloud-based banking infrastructure.", icon: "☁️" },
//     { title: "Fintech Integration", desc: "Seamless integration with third-party fintech services.", icon: "🔗" },
//     ];

//     const team = [
//     { name: "Shivam Kumar", role: "CEO", img: "https://via.placeholder.com/150" },
//     { name: "Rahul Raj", role: "CTO", img: "https://via.placeholder.com/150" },
//     { name: "Anita Singh", role: "Lead Developer", img: "https://via.placeholder.com/150" },
//     { name: "Rohit Verma", role: "Head of AI Solutions", img: "https://via.placeholder.com/150" },
//     ];

//     const testimonials = [
//     { name: "Rajesh Sharma", feedback: "Tech Vision transformed our banking platform completely!" },
//     { name: "Priya Verma", feedback: "Secure, fast, and reliable fintech solutions for our business." },
//     { name: "Ankit Jain", feedback: "AI solutions reduced operational costs by 30%." },
//     ];

//     const caseStudies = [
//     { bank: "Global Bank", challenge: "Outdated banking system.", solution: "Migrated to digital banking platform.", outcome: "Improved efficiency by 50%." },
//     { bank: "Future Finance", challenge: "Fraud detection issues.", solution: "Implemented AI security protocols.", outcome: "Zero security breaches in 2 years." },
//     ];

//     function AboutUs() {
//     return (
//         <div className="font-sans text-gray-800">
//         {/* Navbar */}
//         <Navbarlanding />

//         {/* Hero Section */}
//         <section className="hero relative bg-gradient-to-r from-green-500 to-green-700 text-white py-32 px-6 flex flex-col justify-center items-center text-center">
//             <h1 className="text-4xl md:text-5xl font-bold mb-4">Empowering Banks with Smart, Secure & Scalable Solutions</h1>
//             <p className="text-lg md:text-xl mb-6 max-w-xl mx-auto">
//             Tech Vision Banking Solutions integrates advanced technology and financial expertise to deliver cutting-edge digital banking platforms.
//             </p>
//             <button className="bg-white text-green-700 font-semibold px-6 py-3 rounded-lg hover:bg-gray-100 transition">
//             Learn More
//             </button>
//         </section>

//         {/* Who We Are */}
//         <section className="py-20 px-6 bg-gray-50 text-center">
//             <h2>Who We Are</h2>
//             <p className="max-w-2xl mx-auto mb-6">
//             Tech Vision Banking Solutions was founded to drive innovation in the banking industry through AI, cloud computing, and secure fintech platforms. We focus on creating scalable, customer-centric, and intelligent banking systems.
//             </p>
//             <img src="https://via.placeholder.com/900x400" alt="Team working" className="mx-auto rounded-lg shadow-lg" />
//         </section>

//         {/* Mission, Vision & Values */}
//         <section className="py-20 px-6 text-center bg-white">
//             <h2>Mission, Vision & Core Values</h2>
//             <div className="mvv-grid flex flex-col md:flex-row justify-center gap-8">
//             <div className="mvv-card bg-gray-50 p-8 rounded-lg shadow hover:shadow-lg transition">
//                 <h3 className="text-xl font-semibold mb-4">Mission</h3>
//                 <p>Deliver intelligent, secure banking solutions to enhance customer experiences and operational efficiency.</p>
//             </div>
//             <div className="mvv-card bg-gray-50 p-8 rounded-lg shadow hover:shadow-lg transition">
//                 <h3 className="text-xl font-semibold mb-4">Vision</h3>
//                 <p>Become the most trusted and innovative fintech provider globally, shaping the future of digital banking.</p>
//             </div>
//             <div className="mvv-card bg-gray-50 p-8 rounded-lg shadow hover:shadow-lg transition text-left">
//                 <h3 className="text-xl font-semibold mb-4">Core Values</h3>
//                 <ul className="list-disc list-inside">
//                 <li>Innovation & Technology</li>
//                 <li>Customer-Centric Approach</li>
//                 <li>Trust & Security</li>
//                 <li>Collaboration & Excellence</li>
//                 </ul>
//             </div>
//             </div>
//         </section>

//         {/* Banking Solutions */}
//         <section className="py-20 px-6 bg-gray-50 text-center">
//             <h2>Our Banking Solutions</h2>
//             <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
//             {services.map((service, index) => (
//                 <div key={index} className="service-card bg-white p-6 rounded-lg shadow hover:shadow-lg transition transform hover:scale-105">
//                 <div className="text-5xl mb-4">{service.icon}</div>
//                 <h3 className="text-xl font-semibold mb-2">{service.title}</h3>
//                 <p>{service.desc}</p>
//                 </div>
//             ))}
//             </div>
//         </section>

//         {/* Achievements */}
//         <section className="py-20 px-6 text-center">
//             <h2>Our Achievements</h2>
//             <div className="achievements flex flex-col md:flex-row justify-center gap-12 text-xl font-semibold">
//             <div>
//                 <p className="counter text-green-500">500+</p>
//                 <p>Projects Completed</p>
//             </div>
//             <div>
//                 <p className="counter text-green-500">50+</p>
//                 <p>Awards & Recognitions</p>
//             </div>
//             <div>
//                 <p className="counter text-green-500">100k+</p>
//                 <p>Happy Customers</p>
//             </div>
//             <div>
//                 <p className="counter text-green-500">20+</p>
//                 <p>Banks Served</p>
//             </div>
//             </div>
//         </section>

//         {/* Case Studies */}
//         <section className="py-20 px-6 bg-gray-50 text-center">
//             <h2>Success Stories</h2>
//             <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
//             {caseStudies.map((caseStudy, index) => (
//                 <div key={index} className="case-card bg-white p-6 rounded-lg shadow hover:shadow-lg transition flex-1 text-left">
//                 <h3 className="text-xl font-semibold mb-2">{caseStudy.bank}</h3>
//                 <p><strong>Challenge:</strong> {caseStudy.challenge}</p>
//                 <p><strong>Solution:</strong> {caseStudy.solution}</p>
//                 <p><strong>Outcome:</strong> {caseStudy.outcome}</p>
//                 </div>
//             ))}
//             </div>
//         </section>

//         {/* Testimonials */}
//         <section className="py-20 px-6 bg-white text-center">
//             <h2>Testimonials</h2>
//             <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
//             {testimonials.map((test, index) => (
//                 <div key={index} className="testimonial-card bg-gray-50 p-6 rounded-lg shadow hover:shadow-lg transition">
//                 <p className="italic mb-4">"{test.feedback}"</p>
//                 <p className="font-semibold">{test.name}</p>
//                 </div>
//             ))}
//             </div>
//         </section>

//         {/* Team */}
//         <section className="py-20 px-6 text-center bg-gray-50">
//             <h2>Meet Our Team</h2>
//             <div className="grid md:grid-cols-4 gap-8 max-w-6xl mx-auto">
//             {team.map((member, index) => (
//                 <div key={index} className="team-card flex flex-col items-center bg-white p-6 rounded-lg shadow hover:shadow-lg transition transform hover:scale-105">
//                 <img src={member.img} alt={member.name} className="w-32 h-32 rounded-full mb-4" />
//                 <h3 className="text-xl font-semibold">{member.name}</h3>
//                 <p className="text-gray-500">{member.role}</p>
//                 </div>
//             ))}
//             </div>
//         </section>

//         {/* Call to Action */}
//         <section className="cta py-20 px-6 bg-green-500 text-white text-center rounded-lg mx-6 md:mx-32 my-12">
//             <h2 className="text-3xl font-bold mb-6">Ready to Transform Your Banking Experience?</h2>
//             <p className="mb-6 max-w-xl mx-auto">Get in touch with us today for a free consultation and explore how Tech Vision can innovate your banking solutions.</p>
//             <button className="bg-white text-green-700 font-semibold px-6 py-3 rounded-lg hover:bg-gray-100 transition">
//             Contact Us
//             </button>
//         </section>

//         {/* Footer */}
//         <Footerlanding />
//         </div>
//     );
//     }

//     export default AboutUs;


// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import "../css/AboutUs.css";
// import Footerlanding from "../landing/Footerlanding";
// import Navbarlanding from "../landing/Navbarlanding";
// import { parse } from "tldts";

// const services = [
//   { title: "Savings Account", desc: "Secure and easy-to-manage digital savings accounts.", icon: "🏦" },
//   { title: "Recurring Deposit (RD)", desc: "Grow your savings systematically with recurring deposits.", icon: "📈" },
//   { title: "Fixed Deposit (FD)", desc: "Safe and high-return fixed deposit investment options.", icon: "💰" },
//   { title: "Virtual Account", desc: "Virtual accounts for seamless digital transactions.", icon: "💳" },
//   { title: "Group Loan", desc: "Affordable group loans for communities and organizations.", icon: "👥" },
//   { title: "Personal & Business Loans", desc: "Fast and transparent loans for personal and business needs.", icon: "🤝" },
// ];

// const values = [
//   "Trust: Customer trust is our greatest asset",
//   "Transparency: Clear processes with no hidden charges",
//   "Security: High-level protection of data and transactions",
//   "Innovation: Continuous use of modern financial technology",
//   "Customer First: Every decision is made with the customer in mind",
// ];

// function AboutUs() {
//   const [company, setCompany] = useState({
//     name: "avantikacredit",
//     logo: "",
//     email: "",
//     phone: "",
//     address: "",
//   });

 
//    const getDomainInfo = () => {
//      const hostname = window.location.hostname;
//      const parsed = parse(hostname);
//      return {
//        domain: parsed.domainWithoutSuffix || "",
//        subdomain: parsed.subdomain || "",
//      };
//    };

//   useEffect(() => {
//     const { domain } = getDomainInfo();
//     const fetchCompany = async () => {
//       try {
//         const response = await axios.get("https://payyug.in/api/get-company", {
//           params: { domain },
//         });
//         const data = response.data;
//         if (data && Object.keys(data).length > 0) {
//           setCompany((prev) => ({
//             ...prev,
//             name: data.name || prev.name,
//             logo: data.logo || prev.logo,
//             email: data.email || prev.email,
//             phone: data.contact || prev.phone,
//             address: data.address || prev.address,
//           }));
//         }
//       } catch (err) {
//         console.error("Company fetch failed:", err);
//       }
//     };
//     fetchCompany();
//   }, []);

//   const getImageUrl = (path) => {
//     if (!path) return "";
//     const cleanPath = path.startsWith("images/") ? path.slice(7) : path;
//     return `https://payyug.in/${cleanPath}`;
//   };

//   return (
//     <div className="font-sans text-gray-800">
//       {/* Navbar */}
//       <Navbarlanding />

//       {/* Hero Section */}
//       <section className="hero relative bg-gradient-to-r from-green-500 to-green-700 text-white py-32 px-6 flex flex-col justify-center items-center text-center">
     
//         <h1 className="text-4xl md:text-5xl font-bold mb-4">
//           About Us – {company.name}
//         </h1>
//         <p className="text-lg md:text-xl mb-6 max-w-2xl mx-auto">
//           {company.name} is a modern and reliable digital banking software platform designed to make banking and financial services simple, secure, and accessible through technology.
//         </p>
//       </section>

//       {/* Who We Are */}
//       <section className="py-20 px-6 bg-gray-50 text-center">
//         <h2>Who We Are</h2>
//         <p className="max-w-3xl mx-auto mb-6">
//           {company.name}  empowers individuals, groups, and small businesses by providing digital solutions that help them manage savings, investments, and credit efficiently.
//           <br />
//           We operate on a fully online, paperless, and user-friendly system, allowing customers to access financial services anytime, anywhere.
//         </p>
//       </section>

//       {/* What We Do */}
//       <section className="py-20 px-6 bg-white text-center">
//         <h2>What We Do</h2>
//         <p className="max-w-3xl mx-auto mb-12">
//           {company.name} provides a unified digital platform where users can apply for and manage multiple financial services online.
//         </p>
//         <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
//           {services.map((service, index) => (
//             <div
//               key={index}
//               className="service-card bg-gray-50 p-6 rounded-lg shadow hover:shadow-lg transition transform hover:scale-105"
//             >
//               <div className="text-5xl mb-4">{service.icon}</div>
//               <h3 className="text-xl font-semibold mb-2">{service.title}</h3>
//               <p>{service.desc}</p>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* Mission */}
//       <section className="py-20 px-6 text-center bg-gray-50">
//         <h2>Our Mission</h2>
//         <p className="max-w-3xl mx-auto">
//           Our mission is to:
//           <br />
//           • Make banking and lending services simple, digital, and secure
//           <br />
//           • Expand access to financial services for all sections of society
//           <br />
//           • Promote financial inclusion through technology
//           <br />
//           • Deliver transparent, reliable, and customer-centric financial solutions
//         </p>
//       </section>

//       {/* Vision */}
//       <section className="py-20 px-6 text-center bg-white">
//         <h2>Our Vision</h2>
//         <p className="max-w-3xl mx-auto">
//           Our vision is to:
//           <br />
//           • Become a trusted digital banking software platform in India
//           <br />
//           • Empower individuals and small businesses financially
//           <br />
//           • Create a paperless, cashless, and hassle-free banking ecosystem
//           <br />
//           • Continuously innovate to meet future financial needs
//         </p>
//       </section>

//       {/* Core Values */}
//       <section className="py-20 px-6 text-center bg-gray-50">
//         <h2>Our Core Values</h2>
//         <div className="max-w-3xl mx-auto text-left">
//           <ul className="list-disc list-inside space-y-2">
//             {values.map((value, index) => (
//               <li key={index}>{value}</li>
//             ))}
//           </ul>
//         </div>
//       </section>

//       {/* Why Choose Us */}
//       <section className="py-20 px-6 text-center bg-white">
//         <h2>Why Choose {company.name}</h2>
//         <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
//           <div className="bg-gray-50 p-6 rounded-lg shadow">100% Online & Digital Platform</div>
//           <div className="bg-gray-50 p-6 rounded-lg shadow">Secure and Scalable Technology</div>
//           <div className="bg-gray-50 p-6 rounded-lg shadow">Fast Processing & Easy Access</div>
//           <div className="bg-gray-50 p-6 rounded-lg shadow">Transparent Policies and Processes</div>
//           <div className="bg-gray-50 p-6 rounded-lg shadow">Dedicated Customer Support System</div>
//         </div>
//       </section>

//       {/* Commitment */}
//       <section className="py-20 px-6 text-center bg-gray-50">
//         <h2>Our Commitment</h2>
//         <p className="max-w-3xl mx-auto">
//           {company.name} is committed to providing:
//           <br />
//           • A secure and reliable digital platform
//           <br />
//           • Ethical, transparent, and responsible services
//           <br />
//           • High-quality banking software solutions
//           <br />
//           to all our users and partners.
//         </p>
//       </section>

//       {/* Disclaimer */}
//       <section className="py-16 px-6 text-center bg-white">
//         <h2>Disclaimer</h2>
//         <p className="max-w-3xl mx-auto text-sm text-gray-600">
//           {company.name} is a digital banking software platform. All services are provided subject to eligibility, applicable rules, terms, and approvals from relevant financial partners.
//         </p>
//       </section>

//       {/* Call to Action */}
//       <section className="cta py-20 px-6 bg-green-500 text-white text-center rounded-lg mx-6 md:mx-32 my-12">
//         <h2 className="text-3xl font-bold mb-6">Ready to Get Started with {company.name}?</h2>
//         <p className="mb-6 max-w-xl mx-auto">
//           Contact us today to explore how our digital banking solutions can simplify and secure your financial journey.
//         </p>
//         <button className="bg-white text-green-700 font-semibold px-6 py-3 rounded-lg hover:bg-gray-100 transition">
//           Contact Us
//         </button>
//       </section>

//       {/* Footer */}
//       <Footerlanding />
//     </div>
//   );
// }

// export default AboutUs;


import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/AboutUs.css";
import Footerlanding from "../landing/Footerlanding";
import Navbarlanding from "../landing/Navbarlanding";
import { parse } from "tldts";

const services = [
  { title: "Personal Loans", desc: "Quick and hassle-free personal loans for your immediate financial needs.", icon: "👤" },
  { title: "Business Loans", desc: "Customized loan solutions to expand and empower your business.", icon: "💼" },
  { title: "Group & Community Loans", desc: "Affordable group lending programs for micro-businesses and communities.", icon: "👥" },
  { title: "Microfinance Solutions", desc: "Easy access to small-ticket loans for self-employment and micro-enterprises.", icon: "🌱" },
  { title: "Emergency Credit", desc: "Fast approval and disbursal for urgent financial requirements.", icon: "⚡" },
  { title: "Vehicle & Equipment Loans", desc: "Flexible credit options to purchase commercial vehicles and equipment.", icon: "🚜" },
];

const values = [
  "Trust: Customer trust and financial dignity are our highest priorities",
  "Transparency: Clear loan terms with zero hidden charges or surprises",
  "Security: Complete protection of customer data and credit information",
  "Financial Inclusion: Bringing credit access to underserved communities",
  "Responsible Lending: Fair interest rates with flexible repayment plans",
];

function AboutUs() {
  const [company, setCompany] = useState({
    name: "",
    logo: "",
    email: "",
    phone: "",
    address: "",
  });

  const getDomainInfo = () => {
    const hostname = window.location.hostname;
    const parsed = parse(hostname);
    return {
      domain: parsed.domainWithoutSuffix || "",
      subdomain: parsed.subdomain || "",
    };
  };

  useEffect(() => {
    const { domain } = getDomainInfo();
    const fetchCompany = async () => {
      try {
        const response = await axios.get("https://payyug.in/api/get-company", {
          params: { domain },
        });
        const data = response.data;
        if (data && Object.keys(data).length > 0) {
          setCompany((prev) => ({
            ...prev,
            name: data.name || prev.name,
            logo: data.logo || prev.logo,
            email: data.email || prev.email,
            phone: data.contact || prev.phone,
            address: data.address || prev.address,
          }));
        }
      } catch (err) {
        console.error("Company fetch failed:", err);
      }
    };
    fetchCompany();
  }, []);

  return (
    <div className="about-page">
      <Navbarlanding />

      {/* Hero Section */}
      <section className="about-hero">
        <h1>About Us – {company.name || "Our Lending Platform"}</h1>
        <p>
          {company.name || "Our Platform"} is a modern and reliable digital loan management platform designed to make credit fast, transparent, and accessible through technology.
        </p>
      </section>

      {/* Who We Are */}
      <section className="about-section light-bg">
        <h2>Who We Are</h2>
        <p className="section-text">
          {company.name || "Our company"} empowers individuals, entrepreneurs, and small businesses by providing accessible credit solutions that help them meet immediate financial needs and fuel long-term growth.
          <br /><br />
          We operate on a fully online, paperless, and user-friendly system, ensuring quick loan processing, minimal documentation, and doorstep or digital service delivery.
        </p>
      </section>

      {/* What We Do */}
      <section className="about-section">
        <h2>What We Do</h2>
        <p className="section-text">
          {company.name || "Our platform"} provides a unified digital ecosystem where customers can apply for, track, and manage various loan products effortlessly.
        </p>

        <div className="service-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Mission */}
      <section className="about-section light-bg">
        <h2>Our Mission</h2>
        <p className="section-text">
          Our mission is to:
          <br />• Simplify the loan application and approval process using digital technology
          <br />• Bridge the credit gap for individuals, micro-enterprises, and rural entrepreneurs
          <br />• Deliver fair, transparent, and affordable lending options
          <br />• Promote financial empowerment and self-reliance across communities
        </p>
      </section>

      {/* Vision */}
      <section className="about-section">
        <h2>Our Vision</h2>
        <p className="section-text">
          Our vision is to:
          <br />• Become a premier and trusted credit platform across India
          <br />• Enable hassle-free, paperless, and instant credit delivery to millions
          <br />• Foster sustainable economic growth through responsible lending practices
          <br />• Continuously innovate loan products to match evolving borrower needs
        </p>
      </section>

      {/* Core Values */}
      <section className="about-section light-bg">
        <h2>Our Core Values</h2>
        <ul className="values-list">
          {values.map((value, index) => (
            <li key={index}>{value}</li>
          ))}
        </ul>
      </section>

      {/* Why Choose Us */}
      <section className="about-section">
        <h2>Why Choose {company.name || "Us"}</h2>
        <div className="why-grid">
          <div className="why-card">100% Online & Paperless Application</div>
          <div className="why-card">Quick Loan Approvals & Disbursal</div>
          <div className="why-card">Flexible Tenures & EMI Schedules</div>
          <div className="why-card">Transparent Interest & Fee Structure</div>
          <div className="why-card">Dedicated Loan Relationship Support</div>
        </div>
      </section>

      {/* Commitment */}
      <section className="about-section light-bg">
        <h2>Our Commitment</h2>
        <p className="section-text">
          {company.name || "Our company"} is committed to providing:
          <br />• Fair, ethical, and customer-friendly lending practices
          <br />• Total privacy and security of your personal and credit documents
          <br />• Clear guidance throughout your loan lifecycle from application to closure
        </p>
      </section>

      {/* Disclaimer */}
      <section className="about-section small-text">
        <h2>Disclaimer</h2>
        <p className="section-text">
          {company.name || "Our platform"} is a digital lending and loan facilitation technology platform. All loan sanctions, interest rates, and disbursals are subject to credit evaluation, eligibility criteria, documentation, and applicable regulatory guidelines.
        </p>
      </section>

      {/* Call to Action */}
      <section className="about-cta">
        <h2>Need a Loan or Have Questions?</h2>
        <p>
          Contact our team today to explore customized credit solutions tailored to your financial needs.
        </p>
        <button className="cta-btn">Apply / Contact Us</button>
      </section>

      <Footerlanding />
    </div>
  );
}

export default AboutUs;